import { ToastProvider } from "@circle-react-uikit/ToastV2";
import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import { CheckoutErrorBoundary } from "@circle-react/components/Paywalls/Checkout/CheckoutErrorBoundary";
import { ErrorBoundary } from "@circle-react/components/shared/ErrorPages/ErrorBoundary";
import { ConversionTrackingContextProvider } from "@circle-react/contexts/ConversionTrackingContext";
import { PunditUserContextProvider } from "@circle-react/contexts/punditUserContext";
import { initializeBugsnag } from "@circle-react/helpers/bugsnagHelpers";
import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { createQueryConfig } from "@circle-react/providers/QueryClient/reactQueryConfig";
import {
  applyV2Colors,
  ControlledThemeProvider,
} from "@circle-react/providers/Theme";
import { PaywallCheckoutAppRouter } from "@circle-react/routes/PaywallCheckout/PaywallCheckoutAppRouter";
import { CompassProvider } from "@circleco/compass/context/CompassProvider";
import { CookiesProvider } from "react-cookie";
import { QueryClient } from "react-query";

initializeBugsnag();

const queryClient = new QueryClient(createQueryConfig());

interface PaywallCheckoutAppProps {
  paywallId: number;
}

export const PaywallCheckoutApp = ({ paywallId }: PaywallCheckoutAppProps) => {
  applyV2Colors();

  return (
    <CompassProvider>
      <QueryClientProvider client={queryClient}>
        <PunditUserContextProvider>
          <ErrorBoundary>
            <ControlledThemeProvider>
              <ModalManagerProvider>
                <ToastProvider>
                  <CheckoutErrorBoundary paywallId={paywallId}>
                    <CookiesProvider>
                      <ConversionTrackingContextProvider>
                        <PaywallCheckoutAppRouter paywallId={paywallId} />
                      </ConversionTrackingContextProvider>
                    </CookiesProvider>
                  </CheckoutErrorBoundary>
                </ToastProvider>
              </ModalManagerProvider>
            </ControlledThemeProvider>
          </ErrorBoundary>
        </PunditUserContextProvider>
      </QueryClientProvider>
    </CompassProvider>
  );
};
